var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImageToText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5v14h-20v-14h20zm2-2h-24v18h24v-18zm-14 13.952c-1.551-.265-3-1.615-3-3.242v-2.574l3 2.721v3.095zm2-2.103v-2.814c2.744-.515 2.897-3.494 2.062-5.035l-1.372 1.509-1.183-1.509-1.107 1.509-1.412-1.509c-.812 1.499-.752 4.516 2.012 5.035v4.965h1.489c1.817 0 3.511-1.473 3.511-3.291v-2.574l-4 3.714z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageToText);
export default __webpack_public_path__ + "static/media/icon-imageToText.3eb1a3775dee6594c9c8dd5d7e0820ca.svg";
export { ForwardRef as ReactComponent };